module.exports = __webpack_public_path__ + "img/lta_Logo.7b0c3fbf.png";